import PreviewMixin from '../mixins/preview-mixin'
import _ from '@/assets/lib/my-lodash'
const TableRow = function (year, month, desc, classObject) {
  this.year = year || ''
  this.month = month || ''
  this.description = desc || ''
  this.classObject = classObject || {}
  this.empty = ((this.year + this.month + this.description).length === 0)
}

export default {
  mixins: [PreviewMixin],
  props: {},
  data: function () {
    return {
      maxEduJobRows: 22,
      maxLicenseRows: 6,
      maxLicense4NewRows: 8,
      classObject: {
        reason: {},
        reasonNew: {},
        request: {},
        addressFurigana: {},
        mypr: {}
      },
      textareaMaxHeights: {
        reason: 180,
        reasonNew: 180,
        request: 180,
        addressFurigana: 35
      },
      textMaxLength: {
        commuteDescription: 84
      },
      optionItems: {
        commuteDescription: true
      },
      errorMessages: {
        reason: '',
        reasonNew: '',
        request: '',
        eduJobHistory: '',
        licenseHistory: '',
        mypr: ''
      }
    }
  },
  computed: {
    tel: function () {
      return _.compact([this.basicData.tel1, this.basicData.tel2, this.basicData.tel3]).join('-')
    },
    contactTel: function () {
      return _.compact([this.basicData.contactTel1, this.basicData.contactTel2, this.basicData.contactTel3]).join('-')
    },
    age: function () {
      // console.error(this.basicData)
      // if (!this.basicData.birthYear || !this.basicData.birthMonth || !this.basicData.birthDay || !this.formatData.createDate) {
      //   return ''
      // }
      // const birthDate = new Date(this.basicData.birthYear, this.basicData.birthMonth - 1, this.basicData.birthDay)
      // if (this.formatData.createDate) {
      //   const createDate = new Date(this.formatData.createDate)
      //   const diff = new Date(createDate.getTime() - birthDate.getTime())
      //   const result = Math.abs(diff.getUTCFullYear() - 1970)
      //   if (isNaN(result)) {
      //     return ' '
      //   }

      // }
      return this.basicData.age
    },
    formatedCreateDate: function () {
      if (!this.formatData || !this.formatData.createDate) {
        const nowdate2 = new Date()
        return this.$formLib.dateFormat(nowdate2, 'yyyy年 m月 d日')
        return '<span class="year">&nbsp;</span>年<span class="month">&nbsp;</span>月<span class="day">&nbsp;</span>日'
      } else {
        return this.$formLib.dateFormat(this.formatData.createDate, 'yyyy年 m月 d日')
      }
    },
    isMale: function () {
      return (this.basicData.sex === '1')
    },
    isFemale: function () {
      return (this.basicData.sex === '2')
    },
    isGenderDisplay: function () {
      return (this.basicData.sex === '-1')
    },
    eduJobHistoryTable4New: function () {
      const eduJobHistoryRows = []
      const emptyRow = new TableRow('', '', '', {
        empty: true
      })
      let rowsCount = 0
      // 学歴
      if (this.formatData.educationalHistories && this.formatData.educationalHistories.length) {
        for (const key in this.formatData.educationalHistories) {
          const item = this.formatData.educationalHistories[key]
          const row = new TableRow(item.year, item.month, item.description)
          if (!row.empty) {
            eduJobHistoryRows.push(row)
            rowsCount++
          }
        }
      }

      if (rowsCount && !this.formatData.notDisplayIjyo) {
        const lastRow = new TableRow('', '', '以上', {
          'end-of-content': true
        })
        eduJobHistoryRows.push(lastRow)
      }
      if (eduJobHistoryRows.length > this.maxEduJobRows) {
        const overRowsNum = String(eduJobHistoryRows.length - this.maxEduJobRows)
        this.errorMessages.eduJobHistory = `学歴の行数が ${overRowsNum} 行オーバーしています。義務教育課程の学歴を省略するか、別の履歴書を選んでください。`
      } else {
        this.errorMessages.eduJobHistory = ''
      }
      while (eduJobHistoryRows.length <= this.maxEduJobRows) {
        eduJobHistoryRows.push(emptyRow)
      }
      return eduJobHistoryRows
    },
    eduJobHistoryTable: function () {
      const eduJobHistoryRows = []
      const emptyRow = new TableRow('', '', '', {
        empty: true
      })
      let rowsCount = 0
      // 学歴
      if (this.formatData.educationalHistories && this.formatData.educationalHistories.length) {
        // 学歴見出し
        eduJobHistoryRows.push(new TableRow('', '', '学歴', {
          education: true
        }))

        for (const key in this.formatData.educationalHistories) {
          const item = this.formatData.educationalHistories[key]
          const row = new TableRow(item.year, item.month, item.description)
          if (!row.empty) {
            eduJobHistoryRows.push(row)
            rowsCount++
          }
        }
        // 学歴と職歴の間の空行
        eduJobHistoryRows.push(emptyRow)
      }

      // 職歴
      if (this.formatData.jobHistories && this.formatData.jobHistories.length) {
        // 職歴見出し
        eduJobHistoryRows.push(new TableRow('', '', '職歴', {
          experience: true
        }))

        let jobHistoryCount = 0
        for (const key in this.formatData.jobHistories) {
          // 見出し
          const item = this.formatData.jobHistories[key]
          const row = new TableRow(item.year, item.month, item.description)
          if (!row.empty) {
            jobHistoryCount++
            rowsCount++
            eduJobHistoryRows.push(row)
          }
        }
        if (jobHistoryCount === 0) {
          eduJobHistoryRows.push(new TableRow('', '', 'なし', {
            none: true
          }))
        }
      }

      if (rowsCount && !this.formatData.notDisplayIjyo) {
        const lastRow = new TableRow('', '', '以上', {
          'end-of-content': true
        })
        eduJobHistoryRows.push(lastRow)
      }
      if (eduJobHistoryRows.length > this.maxEduJobRows) {
        const overRowsNum = String(eduJobHistoryRows.length - this.maxEduJobRows)
        this.errorMessages.eduJobHistory = `学歴・職歴の行数が ${overRowsNum} 行オーバーしています。義務教育課程の学歴を省略するか、別の履歴書を選んでください。`
      } else {
        this.errorMessages.eduJobHistory = ''
      }
      while (eduJobHistoryRows.length <= this.maxEduJobRows) {
        eduJobHistoryRows.push(emptyRow)
      }
      return eduJobHistoryRows
    },
    licenseHistory4NewTable: function () {
      const licenseHistoryRows = []
      const emptyRow = new TableRow('', '', '', {
        empty: true
      })
      if (!this.formatData.licenseHistories) {
        this.formatData.licenseHistories = []
      }
      // 学歴
      if (this.formatData.licenseHistories.length === 0) {
        licenseHistoryRows.push(new TableRow('', '', 'なし', {
          none: true
        }))
      } else {
        for (const key in this.formatData.licenseHistories) {
          const item = this.formatData.licenseHistories[key]
          const row = new TableRow(item.year, item.month, item.description)
          if (!row.empty) {
            licenseHistoryRows.push(row)
          }
        }
      }
      if (licenseHistoryRows.length > this.maxLicense4NewRows) {
        const overRowsNum = String(licenseHistoryRows.length - this.maxLicense4NewRows)
        this.errorMessages.licenseHistory = `免許・資格の行数が ${overRowsNum} 行オーバーしています。`
      } else {
        this.errorMessages.licenseHistory = ''
      }
      // 必要な行数まで空行を挿入
      while (licenseHistoryRows.length <= this.maxLicense4NewRows) {
        licenseHistoryRows.push(emptyRow)
      }
      return licenseHistoryRows
    },
    licenseHistoryTable: function () {
      const licenseHistoryRows = []
      const emptyRow = new TableRow('', '', '', {
        empty: true
      })
      let rowsCount = 0
      if (!this.formatData.licenseHistories) {
        this.formatData.licenseHistories = []
      }
      // 学歴
      if (this.formatData.licenseHistories.length === 0) {
        licenseHistoryRows.push(new TableRow('', '', 'なし', {
          none: true
        }))
      } else {
        for (const key in this.formatData.licenseHistories) {
          const item = this.formatData.licenseHistories[key]
          const row = new TableRow(item.year, item.month, item.description)
          if (!row.empty) {
            licenseHistoryRows.push(row)
            rowsCount++
          }
        }
      }
      if (licenseHistoryRows.length > this.maxLicenseRows) {
        const overRowsNum = String(licenseHistoryRows.length - this.maxLicenseRows)
        this.errorMessages.licenseHistory = `免許・資格の行数が ${overRowsNum} 行オーバーしています。`
      } else {
        this.errorMessages.licenseHistory = ''
      }
      if (rowsCount && !this.formatData.notDisplayIjyoLicense) {
        const lastRow = new TableRow('', '', '以上', {
          'end-of-content': true
        })
        licenseHistoryRows.push(lastRow)
      }
      // 必要な行数まで空行を挿入
      while (licenseHistoryRows.length <= this.maxLicenseRows) {
        licenseHistoryRows.push(emptyRow)
      }
      return licenseHistoryRows
    }
  },
  methods: {
    adjustFontSize: function (refName) {
      this.classObject[refName] = {}
      this.errorMessages[refName] = ''
      this.$nextTick(function () {
        if (!this.$refs[refName]) return
        // console.log('getBoundingClientRect.height:', this.$refs[refName].getBoundingClientRect().height)
        // console.log('clientHeight:', this.$refs[refName].clientHeight)
        const maxHeight = this.textareaMaxHeights[refName]
        if (this.$refs[refName].clientHeight > maxHeight) {
          this.classObject[refName] = {
            'font-size-sm': true
          }
        } else {
          this.classObject[refName] = {}
        }
        this.$nextTick(function () {
          if (this.$refs[refName].clientHeight > maxHeight) {
            this.errorMessages[refName] = '入力欄をオーバーしてます'
            this.classObject[refName] = { 'font-size-sm': true, error: true }
          }
        })
      })
    }
  },
  watch: {
    'formatData.reason': _.debounce(function () {
      this.adjustFontSize('reason')
    }, 500),
    'formatData.reasonNew': _.debounce(function () {
      this.adjustFontSize('reasonNew')
    }, 500),
    'formatData.request': _.debounce(function () {
      this.adjustFontSize('request')
    }, 500),
    'basicData.addressFurigana': _.debounce(function () {
      this.adjustFontSize('addressFurigana')
    }, 500)
  }
}
